import React from "react";
import { ICON } from "./constants";

const NewCloseIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 9.5C0 4.25329 4.25329 0 9.5 0C14.7441 0.00618666 18.9938 4.25586 19 9.5C19 14.7467 14.7467 19 9.5 19C4.25329 19 0 14.7467 0 9.5ZM13.3991 12.7831C13.4781 12.4812 13.3881 12.1601 13.1635 11.9432L10.7212 9.5L13.1635 7.05677C13.3881 6.83994 13.4781 6.51883 13.3991 6.21688C13.32 5.91493 13.0842 5.67912 12.7823 5.60008C12.4803 5.52104 12.1592 5.61108 11.9424 5.83559L9.5 8.27882L7.05764 5.83559C6.8408 5.61108 6.5197 5.52104 6.21774 5.60008C5.91579 5.67912 5.67998 5.91493 5.60094 6.21688C5.52191 6.51883 5.61195 6.83994 5.83645 7.05677L8.27882 9.5L5.83645 11.9432C5.50916 12.2821 5.51384 12.8208 5.84698 13.1539C6.18011 13.487 6.71876 13.4917 7.05764 13.1644L9.5 10.7212L11.9424 13.1644C12.1592 13.3889 12.4803 13.479 12.7823 13.3999C13.0842 13.3209 13.32 13.0851 13.3991 12.7831Z"
        fill="#1C1C1C"
      />
    </svg>
  );
};

const CountPublicIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 5C11 6.6575 9.6575 8 8 8C6.3425 8 5 6.6575 5 5C5 3.3425 6.3425 2 8 2C9.6575 2 11 3.3425 11 5ZM2 12.5C2 10.505 5.9975 9.5 8 9.5C10.0025 9.5 14 10.505 14 12.5V14H2V12.5Z"
        fill="#424242"
      />
    </svg>
  );
};
const RatingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <rect width="14" height="14" rx="1.4" fill="#007E33" />
      <path
        d="M6.99935 10.0745L10.6043 12.2503L9.64768 8.14949L12.8327 5.39033L8.63852 5.03449L6.99935 1.16699L5.36018 5.03449L1.16602 5.39033L4.35102 8.14949L3.39435 12.2503L6.99935 10.0745Z"
        fill="white"
      />
    </svg>
  );
};

const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M16.6523 6.04621C16.543 5.70813 16.2432 5.46802 15.8884 5.43605L11.0695 4.99849L9.16402 0.538446C9.02352 0.211582 8.70353 0 8.34801 0C7.99248 0 7.6725 0.211582 7.53199 0.53921L5.62648 4.99849L0.806838 5.43605C0.452715 5.46878 0.153621 5.70813 0.0436901 6.04621C-0.066241 6.38428 0.0352828 6.75509 0.303168 6.98884L3.94567 10.1833L2.87158 14.9147C2.79299 15.2626 2.92801 15.6222 3.21666 15.8308C3.37181 15.9429 3.55333 16 3.73638 16C3.89421 16 4.05076 15.9575 4.19126 15.8734L8.34801 13.389L12.5032 15.8734C12.8073 16.0563 13.1906 16.0396 13.4786 15.8308C13.7674 15.6215 13.9023 15.2618 13.8237 14.9147L12.7496 10.1833L16.3921 6.98947C16.66 6.75509 16.7623 6.38492 16.6523 6.04621Z"
        fill="#FFC107"
      />
    </svg>
  );
};
const WriteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <g clip-path="url(#clip0_1060_331)">
        <path
          d="M11.8749 7.52885C11.5293 7.52885 11.25 7.80888 11.25 8.15381V13.1538C11.25 13.4982 10.9699 13.7788 10.625 13.7788H1.87498C1.52995 13.7788 1.25002 13.4982 1.25002 13.1538V4.40381C1.25002 4.05946 1.52995 3.77885 1.87498 3.77885H6.87502C7.22063 3.77885 7.49998 3.49881 7.49998 3.15388C7.49998 2.80885 7.22063 2.52881 6.87502 2.52881H1.87498C0.84124 2.52881 -1.52588e-05 3.37006 -1.52588e-05 4.40381V13.1538C-1.52588e-05 14.1876 0.84124 15.0288 1.87498 15.0288H10.625C11.6588 15.0288 12.5 14.1876 12.5 13.1538V8.15381C12.5 7.8082 12.2206 7.52885 11.8749 7.52885Z"
          fill="white"
        />
        <path
          d="M5.85994 6.95949C5.81623 7.0032 5.78681 7.05882 5.77434 7.11879L5.33248 9.32887C5.31188 9.4313 5.34439 9.53693 5.41809 9.61131C5.47748 9.67071 5.55747 9.70252 5.63941 9.70252C5.65933 9.70252 5.68004 9.70069 5.70064 9.69634L7.91004 9.25449C7.97126 9.2419 8.02688 9.2126 8.07003 9.16877L13.015 4.22378L10.8056 2.0145L5.85994 6.95949Z"
          fill="white"
        />
        <path
          d="M14.5425 0.486376C13.9332 -0.123022 12.9419 -0.123022 12.3331 0.486376L11.4681 1.35132L13.6775 3.56072L14.5425 2.69566C14.8375 2.40132 15 2.00878 15 1.5913C15 1.17382 14.8375 0.78129 14.5425 0.486376Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1060_331">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M13.1324 2.90245L11.7974 1.57495L4.37988 8.99995L11.8049 16.425L13.1324 15.0975L7.03488 8.99995L13.1324 2.90245Z"
        fill="#212121"
      />
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle opacity="0.2" cx="12" cy="12" r="12" fill="#757575" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.6365 16.8492L12 13.2126L8.36345 16.8492L7.15127 15.637L10.7878 12.0004L7.15127 8.36387L8.36345 7.15169L12 10.7882L15.6365 7.15169L16.8487 8.36387L13.2122 12.0004L16.8487 15.637L15.6365 16.8492Z"
        fill="#757575"
      />
    </svg>
  );
};

const ForwardArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
};

const DownArrowIcon = () => {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.32463L12.3492 0.673828L7.00003 6.02298L1.65088 0.673828L3.04454e-05 2.32462L7.00003 9.32462L14 2.32463Z"
        fill="#002953"
      />
    </svg>
  );
};

const DoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      fill="currentColor"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M9 16.17l-3.88-3.88a.996.996 0 111.41-1.41L9 13.34l8.47-8.47a.996.996 0 111.41 1.41L9 16.17z" />
    </svg>
  );
};

const LineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="296"
      height="2"
      viewBox="0 0 296 2"
      fill="none"
    >
      <path d="M0 1H296" stroke="#EEEEEE" stroke-dasharray="6 6" />
    </svg>
  );
};

const MessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.9314 2.98883H3.67701C2.39552 2.98883 1.35852 4.03033 1.35852 5.31185V12.5616C1.35852 13.2047 1.61664 13.7843 2.03777 14.2054C2.45436 14.6265 3.034 14.8847 3.67701 14.8847C3.83098 14.8847 3.94872 15.0205 3.92606 15.179L3.53663 17.6786C3.49589 17.9232 3.78568 18.0681 3.95776 17.896L6.96003 14.9571C7.00983 14.9118 7.0687 14.8847 7.13664 14.8847H16.9314C18.2129 14.8847 19.2544 13.8477 19.2544 12.5616V5.31185C19.2544 4.03033 18.2129 2.98883 16.9314 2.98883ZM6.66571 8.73975L6.02267 9.36466C5.96833 9.419 5.94116 9.50053 5.95476 9.5775L6.10871 10.4605C6.14041 10.6507 5.93663 10.8002 5.76455 10.7096L4.96759 10.293C4.89966 10.2568 4.81815 10.2568 4.75021 10.293L3.94872 10.7096C3.77665 10.8002 3.57287 10.6552 3.6091 10.4605L3.75852 9.5775C3.77211 9.50053 3.74494 9.42353 3.69061 9.36919L3.04757 8.73975C2.90719 8.59938 2.98419 8.36392 3.17891 8.33222L4.06644 8.20542C4.14344 8.19638 4.21135 8.14655 4.24758 8.07864L4.64607 7.26805C4.73211 7.09147 4.9857 7.09147 5.07173 7.26805L5.46569 8.07864C5.50193 8.14655 5.56984 8.19638 5.64684 8.20542L6.53437 8.33222C6.72908 8.36392 6.80608 8.59938 6.66571 8.73975ZM12.1132 8.73975L11.4702 9.36466C11.4159 9.419 11.3887 9.50053 11.4023 9.5775L11.5563 10.4605C11.588 10.6507 11.3887 10.8002 11.2121 10.7096L10.4151 10.293C10.3472 10.2568 10.2657 10.2568 10.1978 10.293L9.40079 10.7096C9.22418 10.8002 9.02493 10.6552 9.05663 10.4605L9.20608 9.5775C9.21965 9.50053 9.19248 9.42353 9.13814 9.36919L8.49513 8.73975C8.35475 8.59938 8.43173 8.36392 8.62644 8.33222L9.514 8.20542C9.59097 8.19638 9.65891 8.14655 9.69514 8.07864L10.0936 7.26805C10.1796 7.09147 10.4333 7.09147 10.5193 7.26805L10.9133 8.07864C10.9495 8.14655 11.0174 8.19638 11.0944 8.20542L11.9819 8.33222C12.1766 8.36392 12.2536 8.59938 12.1132 8.73975ZM17.5608 8.73975L16.9178 9.36466C16.8634 9.419 16.8408 9.50053 16.8544 9.5775L17.0038 10.4605C17.04 10.6507 16.8363 10.8002 16.6597 10.7096L15.8672 10.293C15.7948 10.2568 15.7132 10.2568 15.6453 10.293L14.8484 10.7096C14.6763 10.8002 14.4725 10.6552 14.5042 10.4605L14.6536 9.5775C14.6672 9.50053 14.64 9.42353 14.5857 9.36919L13.9427 8.73975C13.8023 8.59938 13.8793 8.36392 14.074 8.33222L14.9661 8.20542C15.0431 8.19638 15.1064 8.14655 15.1427 8.07864L15.5412 7.26805C15.6317 7.09147 15.8808 7.09147 15.9668 7.26805L16.3653 8.07864C16.397 8.14655 16.4649 8.19638 16.5419 8.20542L17.4295 8.33222C17.6242 8.36392 17.7012 8.59938 17.5608 8.73975Z"
        fill="#212121"
      />
      <path
        d="M22.6416 8.35036V15.6047C22.6416 16.2477 22.3789 16.8274 21.9623 17.2485C21.5412 17.6651 20.9571 17.9232 20.3186 17.9232C20.1646 17.9232 20.0469 18.0636 20.074 18.2176L20.4589 20.7172C20.4997 20.9617 20.2099 21.1066 20.0378 20.939L17.0355 17.9956C16.9857 17.9549 16.9269 17.9232 16.8589 17.9232H7.06424C6.54801 17.9232 6.07254 17.7557 5.68762 17.4704L7.40387 15.7904H16.9314C18.711 15.7904 20.1601 14.3413 20.1601 12.5617V6.02734H20.3186C21.6001 6.02734 22.6416 7.06434 22.6416 8.35036Z"
        fill="#212121"
      />
    </svg>
  );
};

const CommanSportsIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_752_3185)">
      <path
        d="M2.92126 4.32617L1.47778 5.0089L1.64777 6.46351L3.22499 6.72823L3.95788 5.43247L2.92126 4.32617Z"
        fill="white"
      />
      <path
        d="M4.97214 2.46479L5.11147 2.26414C4.64052 2.09415 4.13058 2.01614 3.62897 2.04122C3.34754 2.05516 3.06885 2.09973 2.79578 2.17497L3.52308 2.55394L4.97214 2.46479Z"
        fill="white"
      />
      <path
        d="M5.63537 5.05912L6.06172 3.9166L4.99724 2.79639L3.60672 2.88276L3.15527 4.08101L4.23091 5.22911L5.63537 5.05912Z"
        fill="white"
      />
      <path
        d="M0.909287 11.4575L1.03468 11.5439C1.07925 11.438 1.11271 11.3265 1.13779 11.215L0.967802 11.176L1.04584 10.85L1.17681 10.8806C1.17681 10.8667 1.17681 10.8528 1.17681 10.8388C1.17681 10.7748 1.17123 10.7107 1.16567 10.6466L1.04306 10.6744L0.965024 10.3484L1.09877 10.3177C1.07369 10.2341 1.04304 10.1505 1.00682 10.0725L0.906508 10.1422L0.717023 9.8663L0.834054 9.78548C0.775538 9.70189 0.708664 9.62665 0.636209 9.5542C0.293454 9.89137 0.0983887 10.3512 0.0983887 10.836C0.0983887 11.3237 0.293454 11.7835 0.638988 12.1207C0.725383 12.0343 0.806174 11.9395 0.873071 11.8392L0.719802 11.7333L0.909287 11.4575Z"
        fill="white"
      />
      <path
        d="M1.89566 8.70435C2.04057 8.70435 2.18268 8.71829 2.31923 8.74615V8.13867C2.11581 8.3226 1.94304 8.51208 1.80371 8.70715C1.83437 8.70435 1.865 8.70435 1.89566 8.70435Z"
        fill="white"
      />
      <path
        d="M1.19626 8.62589L0.873025 7.6645L0.335205 7.4165C0.53863 7.87351 0.831229 8.28314 1.19626 8.62589Z"
        fill="white"
      />
      <path
        d="M1.27431 6.61976C1.28545 6.59468 1.30217 6.57519 1.32169 6.56125L1.14056 5.01746L0.229327 4.54932C0.00360251 5.17351 -0.0604702 5.85066 0.0593389 6.51945C0.0871956 6.67272 0.123435 6.82319 0.16801 6.97087L0.928753 7.32477L1.27431 6.61976Z"
        fill="white"
      />
      <path
        d="M2.82645 4.00044L3.28068 2.80499L2.36108 2.32568C1.76475 2.57091 1.23529 2.96662 0.83124 3.47378C0.641754 3.71064 0.482905 3.967 0.354736 4.2401L1.29941 4.72497L2.82645 4.00044Z"
        fill="white"
      />
      <path
        d="M1.56406 6.78955L1.18787 7.55865L1.51948 8.53676C1.73405 8.22744 2.02942 7.92649 2.38612 7.65061C2.64528 7.44996 2.92952 7.26883 3.23326 7.11279L3.2054 7.06541L1.56406 6.78955Z"
        fill="white"
      />
      <path
        d="M10.8324 5.8309C11.6071 4.93083 12.7022 4.37629 13.8837 4.28434C13.6803 3.44278 13.2205 2.68482 12.5657 2.11914L10.0828 5.23177L10.8324 5.8309Z"
        fill="white"
      />
      <path
        d="M9.82093 5.02301L12.3038 1.91034C11.5876 1.38366 10.721 1.10222 9.83487 1.105C9.98814 2.25865 9.68718 3.42905 8.99609 4.36534L9.82093 5.02301Z"
        fill="white"
      />
      <path
        d="M11.0944 6.03726L13.1927 7.71479C13.8475 6.82308 14.1206 5.70842 13.9506 4.61328C12.8443 4.68854 11.8189 5.20126 11.0944 6.03726Z"
        fill="white"
      />
      <path
        d="M3.25838 9.1947C3.26116 9.1947 3.26396 9.19748 3.26674 9.20028C3.30576 9.23372 3.34197 9.26716 3.37821 9.3006C3.46181 9.38141 3.53426 9.465 3.60114 9.5486V7.2998C3.25838 7.45863 2.9407 7.64814 2.65369 7.8627V8.84081C2.87105 8.9244 3.07726 9.04424 3.25838 9.1947Z"
        fill="white"
      />
      <path
        d="M2.53941 12.1455L2.34993 11.8696L2.49484 11.7721C2.42238 11.6244 2.36664 11.4684 2.33043 11.3067L2.18274 11.343L2.1047 11.0169L2.28305 10.9751C2.28027 10.9277 2.27747 10.8832 2.27747 10.8358C2.27747 10.7383 2.28305 10.6435 2.29697 10.5488L2.10468 10.5042L2.18272 10.1782L2.36942 10.2227C2.40844 10.089 2.46138 9.96357 2.52547 9.84096L2.35271 9.72393L2.54219 9.44805L2.7066 9.55952C2.76511 9.48149 2.82921 9.40906 2.89608 9.33938C2.60071 9.14154 2.25515 9.03564 1.89568 9.03564C1.53898 9.03564 1.19345 9.14154 0.898071 9.33938C0.976107 9.4202 1.04854 9.50657 1.11263 9.59574L1.33 9.44805L1.51948 9.72393L1.2882 9.88276C1.34394 9.99701 1.39132 10.1168 1.42753 10.2395L1.68947 10.1781L1.76751 10.5042L1.49721 10.5683C1.50835 10.6547 1.51393 10.7466 1.51393 10.8358C1.51393 10.8748 1.51393 10.9166 1.51115 10.9556L1.76751 11.0169L1.68947 11.343L1.46375 11.29C1.43031 11.4433 1.38016 11.591 1.31606 11.7331L1.51948 11.8724L1.33 12.1483L1.14887 12.0257C1.07642 12.1344 0.992825 12.2375 0.898071 12.3322C1.19345 12.5273 1.54178 12.636 1.8901 12.6332C2.25235 12.6332 2.5979 12.5273 2.8905 12.3295C2.80691 12.2459 2.73168 12.1539 2.66478 12.0592L2.53941 12.1455Z"
        fill="white"
      />
      <path
        d="M9.50044 1.11914C8.41925 1.21109 7.41606 1.72106 6.70825 2.53754L8.7369 4.15655C9.37783 3.28436 9.65093 2.192 9.50044 1.11914Z"
        fill="white"
      />
      <path
        d="M7.20144 4.10043C6.95622 3.62671 6.61069 3.20592 6.1899 2.86874C5.95303 2.68204 5.69945 2.52321 5.42915 2.39502L5.27869 2.60958L6.35153 3.73816L7.20144 4.10043Z"
        fill="white"
      />
      <path
        d="M10.3476 9.45651C10.3782 9.43144 10.4117 9.40636 10.4451 9.38128C10.3364 8.8992 9.87943 8.32236 9.23572 7.84863V11.3403C9.35833 11.2511 9.47258 11.1591 9.58125 11.0616C9.59241 10.4402 9.86829 9.85778 10.3476 9.45651Z"
        fill="white"
      />
      <path
        d="M11.6294 12.006C11.2867 12.006 10.9523 11.8611 10.7377 11.6215C10.5649 11.4292 10.4841 11.1896 10.5092 10.9499C10.5203 10.8552 10.5399 10.7381 10.5621 10.6044C10.6095 10.3229 10.6764 9.92724 10.6541 9.6458C10.6234 9.6681 10.5928 9.69318 10.5621 9.71825C10.1525 10.061 9.91565 10.5626 9.91565 11.0976C9.91565 11.6299 10.1525 12.1343 10.5621 12.477C10.8854 12.7473 11.295 12.895 11.7158 12.895C12.1839 12.895 12.627 12.7167 12.9642 12.3906C13.3181 12.0479 13.5132 11.5881 13.516 11.1032C13.516 10.61 13.3209 10.1502 12.967 9.8074C12.9001 9.74331 12.8277 9.68479 12.7524 9.63184C12.719 9.90772 12.7998 10.3146 12.8556 10.6016C12.8806 10.7353 12.9057 10.8524 12.9168 10.9499C12.9475 11.1868 12.8695 11.4236 12.6995 11.6159C12.4821 11.8584 12.1477 12.0061 11.7994 12.0061H11.6294V12.006Z"
        fill="white"
      />
      <path
        d="M10.6234 6.09032L9.87377 5.49121L8.60864 7.07679C8.79535 7.17432 8.98206 7.27744 9.1576 7.39169C9.40282 7.55052 9.62855 7.7205 9.82639 7.90163C9.95458 7.24678 10.2249 6.63092 10.6234 6.09032Z"
        fill="white"
      />
      <path
        d="M7.95386 12.0285C8.28547 11.9031 8.60315 11.747 8.90131 11.5631V7.6228C8.60313 7.43887 8.28547 7.28005 7.95386 7.15186V12.0285Z"
        fill="white"
      />
      <path
        d="M3.60676 10.2676C3.52037 10.0028 3.36712 9.75762 3.1609 9.5542C3.0968 9.61552 3.04106 9.67959 2.98813 9.74927L3.1609 9.8663L2.97141 10.1422L2.80978 10.0335C2.76521 10.1199 2.72897 10.2091 2.70111 10.301L2.90176 10.3512L2.82372 10.6772L2.62308 10.6298C2.6175 10.6995 2.61194 10.7692 2.61194 10.8388C2.61194 10.8583 2.61472 10.8806 2.61472 10.9002L2.8265 10.85L2.90454 11.176L2.65932 11.2346C2.68717 11.3544 2.72899 11.4742 2.77915 11.5857L2.96863 11.4575L3.15812 11.7334L2.94911 11.8755C3.01043 11.9619 3.08008 12.0455 3.15812 12.1207C3.50645 11.7779 3.69594 11.3237 3.69872 10.8361C3.69872 10.6521 3.67086 10.4766 3.62068 10.3066C3.61512 10.2954 3.60954 10.2815 3.60676 10.2676Z"
        fill="white"
      />
      <path
        d="M10.9633 9.46231C11.0358 9.80506 10.955 10.2704 10.8909 10.6578C10.8686 10.7859 10.8491 10.8974 10.8407 10.9838C10.8212 11.1677 10.9104 11.3098 10.9856 11.3962C11.1361 11.5634 11.3813 11.6693 11.6266 11.6693H11.7965C12.0445 11.6693 12.2953 11.5634 12.4458 11.3906C12.5211 11.3042 12.6047 11.1677 12.5824 10.9865C12.5712 10.9002 12.5489 10.7887 12.5239 10.6605C12.4458 10.2704 12.3539 9.79946 12.4403 9.45112C12.2146 9.35081 11.9638 9.29785 11.713 9.29785C11.4538 9.2979 11.1974 9.35641 10.9633 9.46231Z"
        fill="white"
      />
      <path
        d="M10.8881 6.30225C10.4785 6.85956 10.2166 7.50886 10.1218 8.19156C10.4256 8.52318 10.6429 8.87149 10.7432 9.19753C11.0414 9.04426 11.3786 8.96344 11.7158 8.96344H11.7241C12.2062 8.71822 12.6298 8.38661 12.9893 7.97698L10.8881 6.30225Z"
        fill="white"
      />
      <path
        d="M9.61182 5.28509L8.78976 4.62744C8.53618 4.92282 8.24916 5.1792 7.93426 5.39654C7.95934 5.62227 7.96492 5.85077 7.95376 6.07647C7.95376 6.10713 7.95098 6.13499 7.94818 6.16564C7.93424 6.36629 7.90361 6.56414 7.85901 6.76198C8.0067 6.81214 8.15439 6.87065 8.29652 6.93197L9.61182 5.28509Z"
        fill="white"
      />
      <path
        d="M6.3543 6.45526L5.67157 5.39355L4.26989 5.56354L3.50635 6.91226L3.53701 6.9652C3.59274 6.94012 3.64848 6.91504 3.70699 6.89274C4.4343 6.59178 5.19504 6.44132 5.96695 6.44132C6.09514 6.44132 6.22611 6.4469 6.3543 6.45526Z"
        fill="white"
      />
      <path
        d="M8.52783 4.41809L7.00354 3.20312C7.27942 3.53474 7.50512 3.91093 7.66397 4.3122C7.66955 4.32892 7.67791 4.34842 7.68347 4.36514C7.76706 4.5797 7.83116 4.79984 7.87576 5.02557C8.11262 4.84724 8.33276 4.64382 8.52783 4.41809Z"
        fill="white"
      />
      <path
        d="M7.60271 7.02946C7.06489 6.86227 6.51315 6.77588 5.96697 6.77588C5.2731 6.77588 4.59037 6.90407 3.93552 7.16043V10.2034C3.99684 10.4068 4.03028 10.6186 4.03028 10.836C4.03028 11.2205 3.92996 11.5884 3.74048 11.9116C3.76834 11.9256 3.79899 11.9367 3.83523 11.9534C4.52632 12.2488 5.24247 12.3993 5.96699 12.3993C6.52431 12.3993 7.07885 12.3129 7.61945 12.1457V7.03504C7.61667 7.03504 7.61387 7.03226 7.61109 7.03226C7.60831 7.03226 7.60549 7.02946 7.60271 7.02946ZM7.09832 9.75756H6.81967V10.0613H6.48527V9.75756H6.25955V10.0613H5.92515V9.75756H5.62697V10.0613H5.29258V9.75756H4.99444V10.0613H4.66005V9.75756H4.40925V9.42316H4.66005V9.10271H4.99444V9.42316H5.29262V9.10271H5.62702V9.42316H5.9252V9.10271H6.25959V9.42316H6.48532V9.10271H6.81971V9.42316H7.09837V9.75756H7.09832Z"
        fill="white"
      />
      <path
        d="M7.18469 6.57227C7.30172 6.60013 7.42155 6.62801 7.53859 6.66145C7.5553 6.57785 7.57202 6.49426 7.58316 6.41064L7.18469 6.57227Z"
        fill="white"
      />
      <path
        d="M7.39651 4.54938L6.34874 4.10352L5.94189 5.19307L6.71936 6.39968L7.61943 6.03463C7.63337 5.73367 7.61385 5.42716 7.55533 5.12898C7.51912 4.93113 7.46338 4.73607 7.39651 4.54938Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_752_3185">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const HighDemandIcon = () => (
  <svg
    width="8"
    height="4"
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.01465 3.38011L2.99965 2L4.41988 3.08503L6.95465 0.860107M6.95465 0.860107L4.98465 0.620117M6.95465 0.860107L6.98465 3"
      stroke="#945918"
      stroke-width="0.8"
    />
  </svg>
);
const WhatsAppLogoIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1591_5619)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2515 1.7425C9.12363 0.619392 7.62353 0.000569818 6.0252 0C2.7317 0 0.051282 2.66533 0.050136 5.94149C0.049563 6.98881 0.324882 8.01106 0.84773 8.91196L0 11.9912L3.16745 11.165C4.0401 11.6385 5.02277 11.8878 6.02263 11.8881H6.0252C9.31813 11.8881 11.9989 9.2225 12 5.94633C12.0006 4.35855 11.3797 2.8659 10.2515 1.74279V1.7425ZM6.0252 10.8847H6.0232C5.1322 10.8844 4.25813 10.6462 3.4955 10.1963L3.31414 10.0892L1.43447 10.5795L1.93611 8.75695L1.81808 8.57006C1.32101 7.78372 1.0583 6.87484 1.05887 5.94179C1.06002 3.2189 3.28778 1.00345 6.02723 1.00345C7.35367 1.00402 8.6005 1.51828 9.53817 2.45193C10.4759 3.38529 10.9918 4.62636 10.9913 5.94577C10.9901 8.66894 8.76237 10.8844 6.0252 10.8844V10.8847ZM8.74917 7.18598C8.5999 7.11162 7.86593 6.75262 7.72897 6.70306C7.59203 6.65347 7.49263 6.62871 7.3932 6.77741C7.2938 6.92615 7.0076 7.26063 6.9205 7.35948C6.8334 7.45863 6.7463 7.4709 6.59703 7.39651C6.4478 7.32215 5.96677 7.16546 5.39637 6.65973C4.9526 6.26599 4.6529 5.77996 4.56583 5.63122C4.47873 5.48251 4.55667 5.40215 4.63113 5.32836C4.69817 5.2617 4.7804 5.15486 4.85517 5.06824C4.92997 4.98162 4.9546 4.91954 5.00443 4.82065C5.0543 4.7215 5.02937 4.63492 4.99213 4.56053C4.95487 4.48618 4.65637 3.75537 4.53173 3.45822C4.41053 3.16876 4.28737 3.20808 4.19597 3.20323C4.10887 3.19896 4.00947 3.19811 3.90977 3.19811C3.81007 3.19811 3.64847 3.23514 3.51153 3.38387C3.3746 3.53257 2.98897 3.89185 2.98897 4.62235C2.98897 5.35286 3.52387 6.05917 3.59863 6.15832C3.6734 6.25747 4.65147 7.75694 6.14897 8.40027C6.5051 8.55325 6.78327 8.64471 7.00013 8.71309C7.3577 8.8262 7.68313 8.81025 7.9404 8.77207C8.2272 8.72934 8.82367 8.4128 8.948 8.06606C9.07233 7.71932 9.07233 7.42187 9.0351 7.36004C8.99787 7.29822 8.89817 7.2609 8.7489 7.18654L8.74917 7.18598Z"
        fill="#25D366"
      />
    </g>
    <defs>
      <clipPath id="clip0_1591_5619">
        <rect width="11.9337" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const svgImageList = {
  [ICON.NEW_CLOSE_ICON]: <NewCloseIcon />,
  [ICON.FORWARD_ARROW_ICON]: <ForwardArrowIcon />,
  [ICON.DOWN_ARROW_ICON]: <DownArrowIcon />,
  [ICON.DONE_ICON]: <DoneIcon />,
  [ICON.RATING_ICON]: <RatingIcon />,
  [ICON.STAR_ICON]: <StarIcon />,
  [ICON.WRITE_ICON]: <WriteIcon />,
  [ICON.BACK_ICON]: <BackIcon />,
  [ICON.CLOSE_ICON]: <CloseIcon />,
  [ICON.MESSAGE_ICON]: <MessageIcon />,
  [ICON.STAR_ICON]: <StarIcon />,
  [ICON.LINE_ICON]: <LineIcon />,
  CommanSportsIcon: <CommanSportsIcon />,
  HighDemandIcon: <HighDemandIcon />,
  [ICON.WHATSAPP_ICON]: <WhatsAppLogoIcon />,
};

/**
 * Utility method to get the corresponding Image.
 * @param {string} imageName - Name of the image to retrieve.
 * @param {string | object} colorOrStyle - color string or style object.
 * @returns {React.Component} - React Image component.
 */
const getSvgIcon = (imageName, colorOrStyle = "") => {
  if (!colorOrStyle) {
    return svgImageList[imageName];
  } else {
    return svgImageList["default_highlight"];
  }
};

const getHighlightSvgIcon = (imageName) => {
  if (imageName in svgImageList) {
    return svgImageList[imageName];
  } else {
    return svgImageList["default_highlight"];
  }
};

//custom svg
function KMlogo() {
  return (
    <svg
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <g id="Homepage" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g id="Home" transform="translate(-24.000000, -16.000000)">
          <g id="Top-Nav" transform="translate(0.000000, 0.000000)">
            <g id="KM-Icon" transform="translate(24.000000, 16.000000)">
              <g id="Combined-Shape">
                <path d="M1.60496794,14.0290541 C7.21249857,14.3500224 11.7976381,18.539301 12.7322979,23.9615259 C12.4327274,23.9842077 12.1288774,24.0000421 11.8224596,24.0000421 C5.89353273,24.0000421 0.972018406,19.6977827 0.000126315788,14.0457444 C0.0741630096,14.040181 0.148627661,14.0333337 0.223092313,14.0290541 C0.451621761,14.0384691 1.37387075,14.0384691 1.60496794,14.0290541 Z M18.676888,2.15070107 C21.7872851,4.31959104 23.8230802,7.91999974 23.8230802,11.9997211 C23.8230802,16.0785866 21.7872851,19.6794233 18.676888,21.8470294 C17.2068531,17.6273658 13.6235627,14.0902948 9.35126031,11.9997211 C13.6235627,9.90829153 17.2068531,6.37336036 18.676888,2.15070107 Z M11.8228876,4.2105262e-05 C12.1288774,4.2105262e-05 12.4327274,0.0150206271 12.7322979,0.0368464733 C11.7976381,5.45992731 7.21249857,9.64834998 1.60496794,9.9693183 C1.37387075,9.95947528 0.451621761,9.95947528 0.223092313,9.97017422 L0.223092313,9.97017422 L0.000126315788,9.95262795 C0.972018406,4.30230154 5.89353273,4.2105262e-05 11.8228876,4.2105262e-05 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export { getSvgIcon, KMlogo, getHighlightSvgIcon };
